import { defineStore } from 'pinia';
import { StoreModuleName } from '../../constants';
import { CustomFetchContext } from '~/src/api/requests/types';
import { ExamResultPageStatus, ExamResultStatus } from './types';
import {
  updateChapterPracticeData,
  updateDailyPunchData,
  updateExamResultData,
  updateListExamResultData,
} from './helper';
import { ExamModeEnum } from '~/src/constants/exam';
import {
  fetchContinueDailyPunchCount,
  fetchContinueDailyPunchActCount,
} from '~/src/api/modules/exam';

export const useExamResultStore = defineStore(StoreModuleName.EXAM_RESULT, () => {
  const examResultPageStatus = reactive<ExamResultPageStatus>({
    meta: {
      mode: ExamModeEnum.PunchInDaily,
      title: '',
      punchCardTime: '',
      status: '',
      isFinished: false,
      sectionId: '',
      chapterId: '',
      date: '',
    },
    dashboard: {
      total: 0,
      done: 0,
      undo: 0,
      success: 0,
      failed: 0,
      accuracy: 0,
      duration: 0,
      progress: 0,
      submitTotalQuestion: 0,
      todayTotalQuestion: 0,
      continueSignCount: 0,
      totalSignCount: 0,
      signTop: 0,
    },
    questList: [],
  });

  const updateStoreData = async (fetchContext: CustomFetchContext) => {
    const { mode, submitId, answerId, sectionId } = examResultPageStatus.meta;
    let result = {} as ExamResultPageStatus;

    if (mode === ExamModeEnum.PunchInDaily) {
      result = await updateDailyPunchData(fetchContext, examResultPageStatus);

      // 获取连续打卡数
      fetchContinueDailyPunchActCount().then(res => {
        examResultPageStatus.dashboard.currentlyDayCount = Number(res.data) || 0;
      });
    } else if (mode === ExamModeEnum.ChapterPractice) {
      result = await updateChapterPracticeData(submitId!, sectionId!, fetchContext);
    } else if (mode === ExamModeEnum.NormalExam) {
      result = await updateExamResultData(answerId!, fetchContext);
    } else if (mode === ExamModeEnum.ImitateExam || mode === ExamModeEnum.PreviousExam) {
      result = await updateListExamResultData(answerId!, fetchContext);
    }

    console.log('result', result.meta);
    examResultPageStatus.meta = {
      ...examResultPageStatus.meta,
      ...result.meta,
    };

    examResultPageStatus.dashboard = {
      ...examResultPageStatus.dashboard,
      ...result.dashboard,
    };

    examResultPageStatus.questList = {
      ...result.questList,
    };
  };

  // footer btns
  const footerBtns = computed(() => {
    return {
      showRetry: examResultPageStatus.meta.mode !== ExamModeEnum.ChapterPractice,
      showHighFrequencyQuest: [
        ExamModeEnum.NormalExam,
        ExamModeEnum.ImitateExam,
        ExamModeEnum.PreviousExam,
      ].includes(examResultPageStatus.meta.mode),
      showChapterPractice:
        examResultPageStatus.meta.mode === ExamModeEnum.PunchInDaily &&
        examResultPageStatus.meta.status === ExamResultStatus.Failed,
      showContinue: examResultPageStatus.meta.mode === ExamModeEnum.ChapterPractice,
      showMockExam:
        examResultPageStatus.meta.mode === ExamModeEnum.PunchInDaily &&
        examResultPageStatus.meta.status === ExamResultStatus.Success,
      showChangeGroup:
        examResultPageStatus.meta.mode === ExamModeEnum.PunchInDaily &&
        examResultPageStatus.meta.status === ExamResultStatus.Success &&
        examResultPageStatus.dashboard.todayTotalQuestion >
          examResultPageStatus.dashboard.submitTotalQuestion,
    };
  });

  return {
    examResultPageStatus,
    updateStoreData,
    footerBtns,
  };
});
